import { render, staticRenderFns } from "./toDoNotificationAcquisitionListsLinkButton.vue?vue&type=template&id=85649496"
import script from "./toDoNotificationAcquisitionListsLinkButton.vue?vue&type=script&lang=ts"
export * from "./toDoNotificationAcquisitionListsLinkButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports